module.exports = __webpack_public_path__ + "static/bch-square-green-160e661d2a30267d0aaf733334e51fff.png";